export const PRO_REQUEST_URL =
  location.protocol +
  `//api.${window.location.host.split('.').slice(1).join('.')}/`;
export const PRO_RESOURCE_URL = `//file.${window.location.host
  .split('.')
  .slice(1)
  .join('.')}/`;
